import { useQuery } from '@hooks/reactQuery';

import { getConfigIdsBranch } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MO_BRANCH_CONFIG_IDS } from '@constants/queryKeys';

interface IUseQueryConfigIdsBranchReturnType {
	configIdsOptions: TSelectOption[];
	isLoadingConfigIds: boolean;
}

export const useQueryConfigIdsBranch = (comparisonId: string): IUseQueryConfigIdsBranchReturnType => {
	const {
		data: configIdsOptions,
		isLoading: isLoadingConfigIds,
	} = useQuery({
		queryKey: [MO_BRANCH_CONFIG_IDS, comparisonId],
		queryFn: extractQueryParams(getConfigIdsBranch),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		...refetchOptions,
	});

	return { configIdsOptions: configIdsOptions || [], isLoadingConfigIds };
};
